import React from 'react'
import { Link } from 'wouter'

export default function NavigationAdmin({ page, settingPage, fullname, mail, type }) {
    return (
        <nav className="navbar-admin navbar-expand-lg navbar-light bg-light">

            <div>


                <Link to='/'>
                    <a class="navbar-brand" href="#">
                        <img src="/assets/vitaly.webp" alt="" width="140" />
                    </a>
                </Link>

                <ul className="links-admin"
                    style={{
                        marginTop: "100px"
                    }}
                >
                    {
                        type != "personal" && <li
                            onClick={() => settingPage("calendar")}
                            className={page == "calendar" ? "nav-item active" : "nav-item"}>
                            <a className="nav-link" aria-current="page" href="#">
                                <img width={"24px"} height={"24px"} src="/assets/icons/new/calendar-black.png" alt="" /> Calendario
                            </a>
                        </li>
                    }

                    {
                        type != "personal" && <li
                            onClick={() => settingPage("products")}
                            className={page == "products" ? "nav-item active" : "nav-item"}>
                            <a className="nav-link" href="#">
                                <img src="/assets/icons/box.svg" alt="" /> Productos
                            </a>
                        </li>}

                    {
                        type != "personal" && <li
                            onClick={() => settingPage("services")}
                            className={page == "services" ? "nav-item active" : "nav-item"}>
                            <a className="nav-link" href="#">
                                <img src="/assets/icons/megaphone.svg" alt="" /> Servicios
                            </a>
                        </li>
                    }

                    {type != "personal" && <li
                        onClick={() => settingPage("patients")}
                        className={page == "patients" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/patients.svg" alt="" /> Lista de pacientes
                        </a>
                    </li>
                    }
                    {type != "personal" && <li
                        onClick={() => settingPage("notifications")}
                        className={page == "notifications" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/bell-ring.svg" alt="" /> Solicitudes de citas
                        </a>
                    </li>
                    }



                    {type == "personal" && <li
                        onClick={() => settingPage("mis-datos")}
                        className={page == "mis-datos" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/patients.svg" alt="" /> Mis datos medicos
                        </a>
                    </li>}

                    {type == "personal" && <li
                        onClick={() => settingPage("mis-citas")}
                        className={page == "mis-citas" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/patients.svg" alt="" /> Mis citas
                        </a>
                    </li>}

                    {type == "personal" && <li
                        onClick={() => settingPage("mis-productos")}
                        className={page == "mis-productos" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/patients.svg" alt="" /> Mis ordenes
                        </a>
                    </li>}

                    {type == "personal" && <li
                        onClick={() => settingPage("mis-favoritos")}
                        className={page == "mis-favoritos" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/patients.svg" alt="" /> Mis favoritos
                        </a>
                    </li>}


                    {type == "personal" && <li
                        onClick={() => settingPage("mis-resultados")}
                        className={page == "mis-resultados" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/patients.svg" alt="" /> Mis resultados
                        </a>
                    </li>}


                </ul>
            </div>

            <div className="user-box">

                {type != "personal" && <li
                    onClick={() => settingPage("settings-plus")}
                    className={page == "settings-plus" ? "nav-item active" : "nav-item"}>
                    <a className="nav-link" href="#">
                        <img src="/assets/icons/settings.svg" alt="" /> Configuraciones
                    </a>
                </li>
                }

                {type != "personal" && <li
                        onClick={() => settingPage("settings-plus")}
                        className={page == "settings-plus" ? "nav-item active" : "nav-item"}>
                        <a className="nav-link" href="#">
                            <img src="/assets/icons/settings.svg" alt="" /> Cerrar sesion
                        </a>
                    </li>
                    }

                <div className="">

                    <a
                        onClick={() => settingPage("settings")}
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center'
                        }}
                        className="btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/3135/3135768.png"
                            alt=""
                            width="60"
                            height={"60px"}
                        />
                        <div className="content"
                            style={{
                                padding: "0 20px",
                                textAlign: "left"
                            }}
                        >
                            <h6 style={{ margin: "0" }}>{fullname}</h6>
                            <span style={{ fontSize: "10px" }}>{mail}</span>
                        </div>
                    </a>
                </div>
            </div>

        </nav>

    )
}
